import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

// import { MatDialog } from '@angular/material/dialog';
// utilidades


@Injectable({
  providedIn: 'root'
})
export class MensajeService {

  static mensajeSesionValida = false;

  constructor(
    // private dialog: MatDialog,
  ) {
  }



  verificarMensajes(data: any) {
    if (data) {
      if (data.resultado) {
        if (data.resultado === 'OK') {
          this.visualizarSuccess(data.mensaje).then(
            elemet => {
              return true
            }
          );
          return true;
        } else if (data.resultado === 'WARNING') {
          // Warning Notificacion
          this.visualizarWarning(data.mensaje);
          return true;
          //
        }
        // Error Notificacion
        this.visualizarError(data.resultado, data.mensajeError);
        //
      }
    } else {
      // Notificacion
      this.visualizarError('Error en el proceso');
      //
    }
    this.visualizarError(data.mensajeError);
    return false;
  }

  visualizarSuccess(texto?: any, titulo?: string) {
    return new Promise((resolve, reject) => {
      Swal.fire({
        icon: 'success',
        title: '¡Bien!',
        text: texto,
        confirmButtonColor: '#3ba936',
      }).then((result) => {
        if (result.isConfirmed) {
          resolve(result.isConfirmed);
        }
        resolve(false);
      })
    });
  }

  visualizarWarning(texto: any, titulo?: string) {
    return new Promise((resolve, reject) => {
      Swal.fire({
        icon: 'warning',
        title: titulo,
        text: texto,
        confirmButtonColor: '#3ba936',
        cancelButtonColor: '#3ba936',

      });
    });
  }

  visualizarError(texto: any, titulo?: string) {
    return new Promise((resolve, reject) => {
      if (texto.status == 403) {
        Swal.fire({
          icon: 'error',
          title: '¡Error!',
          text: 'Su usuario no tiene acceso a este servicio',
          confirmButtonColor: '#3ba936',
          cancelButtonColor: '#3ba936'
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: titulo,
          text: texto,
          confirmButtonColor: '#3ba936',
          cancelButtonColor: '#3ba936'
        });
      }
    });
  }

  visualizarConfirm(texto: string, callback: Function, titulo?: string): any {

    return Swal.fire({
      title: titulo,
      text: texto,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.isConfirmed) {
        return callback(result.isConfirmed);
      }
      return callback(false);
    })
  }

  visualizarConfirmacion(texto: string, titulo?: string): any {
    return new Promise((resolve, reject) => {
      return Swal.fire({
        title: titulo,
        text: texto,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3ba936',
        cancelButtonColor: '#ffffff',
        confirmButtonText: 'Sí',

        cancelButtonText: 'No'
      }).then((result) => {
        if (result.isConfirmed) {
          resolve(result.isConfirmed);
        }
        resolve(false);
      })
    })
  }

  visualizarNoEncuentraInstitucion(texto: string, callback: Function): any {
    return Swal.fire({
      title: '',
      icon: 'warning',
      text: texto,
      showCloseButton: false,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: 'No se encuentra',
      cancelButtonText: 'Intentar nuevamente'
    }).then((result) => {
      if (result.isConfirmed) {
        return callback(result.isConfirmed);
      }
      return callback(false);
    })
  }
}
